// extracted by mini-css-extract-plugin
export default {"main_container":"App_main_container__VrYc-"};